export default __webpack_public_path__ + "static/media/3.a8839ea1.jpg";